/* eslint-disable padding-line-between-statements */
/* eslint-disable no-console */
import React, {
    useState,
    useEffect,
    useContext,
    useCallback
} from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { UserService } from 'gw-capability-gateway';
import { MLErrorMessageUtil } from 'ml-portals-util-js';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { MLWizardNavUtil } from 'ml-portals-util-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLPropertyValuationService, MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { MLHOPropertyValuationComponent, MLHOReplacementCostSummaryComponent, MLAlertGroupComponent } from 'ml-components-common-react';
import HOTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import {MLUWIssuesPanelComponent} from "gw-capability-gateway-quoteandbind-common-react";
import { ScrollToError } from '@jutro/legacy/wizard-next';
import messages from './ConstructionPage.messages';
import metadata from './ConstructionPage.metadata.json5';
import styles from './ConstructionPage.module.scss';

// HOConstructionCtrl.js, ho-construction.html
function ConstructionPage(props) {
    const isGPA = appConfig.portalCode === 'GPA';
    const isQnB = appConfig.portalCode === 'QB';
    const auth = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { wizardData: submissionVM, updateWizardData, currentStep, goNext, isSkipping, steps, history } = props;
    const [showPropertyValuation, updateShowPropertyValuation] = useState(false);
    const [showAdditionalQuestions, updateShowAdditionalQuestions] = useState(false);
    const [replacementCost, setReplacementCost] = useState(false);
    const [editHomeDetails, setEditHomeDetails] = useState(undefined);
    const [closeCovAAlert, updateCloseCovAAlert] = useState(false);
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(false);
    const [blockingUwIssues, setBlockingUwIssues] = useState([]);
    const [disableNextButton, setDisableNextButton] = useState(false);
    const [veriskTokenError, setVeriskTokenError] = useState(false);
    const [userClickOnEdit, setUserClickOnEdit] = useState(false);

    const [showErrors, updateShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const {
        onValidate,
        isComponentValid,
        initialValidation
    } = useValidation('ConstructionPage');
    const USER_TYPE = isGPA? 'AGENT' : 'CONSUMER';
    const CONSTRUCTION_VERISK_DETAILS_PATH = 'lobData.homeowners.coverables.constructionVeriskDetails_ML.value';
    const [token, setToken] = useState();
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    const [canRequote, setCanRequote] = useState(false);

    const isCondo = submissionVM.value.isCondo();
    const isLLCondo = submissionVM.value.isLandlordCondo();
    const hasPreviousReplacementCost = !!_.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.replacementCost.value');
    const primaryHeatingTypeValue = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.primaryHeatingType.value');
    const roofAgeValue = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.roofAge.value');
    const hasDetailsAdditionalQuestions = !!primaryHeatingTypeValue && roofAgeValue >= 0;
    const verisk360ValuationIDValue = _.get(submissionVM, 'lobData.homeowners.coverables.constructionVeriskDetails_ML.verisk360ValuationID_ML.value');
    const verisk360VersionValue = _.get(submissionVM, 'lobData.homeowners.coverables.constructionVeriskDetails_ML.verisk360Version_ML.value');
    const coverageType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', undefined);
    const isCompRater = currentStep.mlStepName === 'compHoDetails';
    const constructionDetailsVM = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML');
    const {nextStepVisited, canShowReturnToQuoteButton} = MLWizardNavUtil(props);
    const offerings = _.get(submissionVM, 'lobData.homeowners.value.offerings');
    const choosenQuote = _.get(submissionVM, 'bindData.chosenQuote.value');
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        addErrorAlert,
        clearBlockAlerts,
    } = MLNotificationBlockUtil();

    const updatePPCFields = useCallback(async () => {
        const hasFireDistrictName = _.get(constructionDetailsVM, 'fireDistrictName.value', undefined);
        if (!isModernProduct || isCompRater || !_.isUndefined(verisk360ValuationIDValue)) return;
        const key = `ppcIntegrationCalled_${submissionVM.quoteID.value}`
        if (sessionStorage.getItem(key)) {
            return;
        }
        sessionStorage.setItem(key, 'true');
        await LoadSaveService.callVeriskIntegration(submissionVM.quoteID.value, auth.authHeader);
    }, [isModernProduct,auth]);

    const generateVeriskToken = useCallback(() => {
        if (veriskTokenError) {
            return; // Prevent re-triggering if error already occurred
        }
        const request = {
            quoteID: submissionVM.quoteID.value,
            userType: USER_TYPE,
            sessionUUID: submissionVM.sessionUUID.value
        };
        showProgressDialog(platformMessages.retrievingHomeDetails);
        MLPropertyValuationService.getPropertyValuationInfoMLByJobNumber(
          request,
          isGPA && auth.authHeader
        )
          .then((data) => {
            setToken(data.tokenId);
            updateShowPropertyValuation(true);
            hideProgressDialog();
          })
          .catch((error) => {
            console.log(error);
            if(error?.errorCode === "GW_PROPERTY_VALUATION_ERROR_ML"){
                hideProgressDialog();
                setVeriskTokenError(true);
                showErrorModal("", translator(messages.veriskTokenErrorMessage));
            }
          });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [USER_TYPE, auth, isGPA, submissionVM.quoteID.value, submissionVM.sessionUUID.value, showErrorModal, hideProgressDialog, veriskTokenError]);

    const isGrandProtectSelected = (offerings) => {
        if (!offerings || !Array.isArray(offerings) || !choosenQuote) {
            return false;
        }
        return offerings.some((offering) => offering.branchCode === 'HOPGrandProtectHome_ML' && offering.branchPublicID === choosenQuote)
    }

    const checkForDwellingConstructionUwIssues = useCallback(() => {
        const uwIssues = submissionVM.errorsAndWarnings?.underwritingIssues?.value;
        if (uwIssues?.length > 0) {
            const dwellingConstructionCheckpointIssues = uwIssues.filter((issue) => {
                return issue.checkingSet_Ext === 'dwelling_construction_ml' && issue.currentBlockingPoint === 'BlocksQuote';
            });
            if (dwellingConstructionCheckpointIssues?.length > 0) {
                setIsUWIssuesPanelVisible(true);
                setBlockingUwIssues(dwellingConstructionCheckpointIssues);
                setDisableNextButton(true);
                return true;
            }
            setDisableNextButton(false);
            return false;
        }
        return false;
    }, [submissionVM]);

    const onInit = useCallback((editHomeDetailsClicked = false) => {
        setReplacementCost(false);
        const tempEditHomeDetails = editHomeDetailsClicked || editHomeDetails;
        if (!hasPreviousReplacementCost || !!tempEditHomeDetails || (!hasDetailsAdditionalQuestions && !(isCondo || isLLCondo))
            || ((isCondo || isLLCondo) && !verisk360ValuationIDValue || !verisk360VersionValue)) {
            generateVeriskToken();
            setEditHomeDetails(false);
        } else {
            updateShowAdditionalQuestions(true);
        }
    }, [editHomeDetails, generateVeriskToken, hasDetailsAdditionalQuestions, hasPreviousReplacementCost, isCondo, isLLCondo, verisk360ValuationIDValue, verisk360VersionValue]);

    const skipOnResumeIf = () => {
        const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)

        if (jumpToQuote) {
            return initialValidation().then((isValid) => !!isValid);
        } else {
        
            if (!!_.get(submissionVM, 'bindData.policyNumber.value')
                && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
                return true;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName) {
                return false;
            }

            if (coverageType === 'hoprental') {
                return true;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }

            if (submissionVM.value.isBundle_ML
                && submissionVM.value.baseData.status_ML !== 'Draft') {
                return true;
            }

            const savedFromPortal = submissionVM.lobData?.homeowners?.coverables?.constructionDetails_ML?.savedFromPortal?.value;
            const constructionReplacementCost = !!_.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.replacementCost.value');
            return (savedFromPortal && constructionReplacementCost);
        }
    };

    const setCanRequoteFlag = useCallback ( async() => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    useEffect(() => {
        if (coverageType !== 'hoprental' && !isSkipping || (isSkipping && !skipOnResumeIf())) {
            onInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isSkipping) {
            if (isGPA) {
                UserService.getCurrentUser(auth.authHeader).then((user) => {
                    HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Construction Page'});
                });
            } else {
                    HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Construction Page'}, true);
            }
        }

        canShowReturnToQuoteButton(submissionVM, auth.authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setCanRequoteFlag();
        if(isGPA){
            updatePPCFields()
        }
    }, [setCanRequoteFlag, submissionVM]);

    const checkForDisableNextButton = useCallback((issues) => {
        if (issues?.length > 0) {
            const questionCheckpointIssues = issues.filter((issue) => {
                return issue.checkingSet_Ext === 'dwelling_construction_ml' && issue.currentBlockingPoint === 'BlocksQuote';
            });
            setDisableNextButton(questionCheckpointIssues?.length > 0);
        }
    }, []);

    const updateValuationData = useCallback((valuationId, version) => {
        const veriskDetails = _.get(submissionVM, CONSTRUCTION_VERISK_DETAILS_PATH);
        veriskDetails.verisk360Version_ML = version;
        veriskDetails.verisk360ValuationID_ML = valuationId;
        veriskDetails.updateDwellingWithVeriskData = true;
    }, [submissionVM]);

    const initDwellingDateModifiers = useCallback(() => {
        let date = new Date();
        const dateModifiers = ['zk9gmhjs1bsr143asmo0m9nmlga', 'z50j8jrtptqs14rv13ms7vbppt8', 'zipj8i6jij6ulbada49qcopeota'];
        const modifiers = _.get(submissionVM, 'lobData.homeowners.modifiers_ML');
        modifiers.dwellingsModifiers_ML.forEach((mod) => {
            if (mod?.patternCode && dateModifiers.includes(mod?.patternCode?.value)) {
                if (mod.dateValue_ML.year !== undefined && mod.dateValue_ML.month !== undefined && mod.dateValue_ML.day !== undefined) {
                    date = new Date(
                        mod.dateValue_ML.year.value,
                        mod.dateValue_ML.month.value,
                        mod.dateValue_ML.day.value
                    );
                }

                _.set(mod, 'chosenTermValue.value', date);
                _.set(mod, 'dateValue_ML.value', MLLocalDateUtil.date2LocalDate(date));
            }
        });
    }, [submissionVM]);

    const showAdditionalQuestionsSection = () => {
        updateShowAdditionalQuestions(true);
        updateShowPropertyValuation(false);
    };

    const setEditModeForDwellingConstructionModifiers = useCallback((value) => {
        const modifiers = _.get(submissionVM, 'lobData.homeowners.modifiers_ML.dwellingConstructionModifiers_ML.value');
        if (!_.isEmpty(modifiers)) {
            modifiers.forEach((modifier) => {
                if (modifier) {
                    modifier.editMode_ML = value;
                }
            });
        }
    }, [submissionVM]);


    const handleVeriskError = (error, fieldName) => {
        const title = translator(messages.veriskErrorMessage);
        let description = translator(messages.tryAgainMessage);
        if (fieldName) {
            description = `${fieldName} is invalid.\n\n${description}` ;
        }
        showErrorModal(title, description, error);
    };

    const checkVeriskYearBuiltIsValid = (subVM) => {
        const veriskYearBuilt = _.get(subVM, 'lobData.homeowners.coverables.constructionVeriskDetails_ML.yearBuilt.value');
        if (veriskYearBuilt) {
            const currentYear = new Date().getFullYear();
            if (veriskYearBuilt > currentYear) {
                handleVeriskError(null, 'Year Built');
            }
        }
    };

    const onFinishVeriskIntegration = useCallback( async(valuationId, version) => {
        setDisableNextButton(false);
        const oldVerisk360Version_ML = _.get(submissionVM, CONSTRUCTION_VERISK_DETAILS_PATH)?.verisk360Version_ML;    
        updateValuationData(valuationId, version);
        setEditModeForDwellingConstructionModifiers(false);
        _.set(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.savedFromPortal.value', false);
        if (!showReturnToQuote || oldVerisk360Version_ML !== version) {
            setShowReturnToQuote(false);
            showProgressDialog(platformMessages.saveSubmission);
            try {
                const newSubmission = viewModelService.clone(submissionVM);
                const res = await LoadSaveService.updateDraftSubmission(newSubmission.value, isGPA && auth.authHeader);
                if (res?.lobData) {
                    _.set(submissionVM, 'value', res);
                    _.set(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.savedFromPortal.value', true);
                    initDwellingDateModifiers();
                    setReplacementCost(true);
                    updateWizardData(submissionVM);
                    if (!!constructionDetailsVM.replacementCost.value && isGrandProtectSelected(offerings) && constructionDetailsVM.isReplacementCostSelected_ML.value) {
                        setDisableNextButton(true);
                    } 
                }
            } catch (error) {
                console.error(error);
                handleVeriskError(error);
            } finally {
                hideProgressDialog();
                showAdditionalQuestionsSection();
            }
        } else {
            updateWizardData(submissionVM);
            showAdditionalQuestionsSection();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [LoadSaveService, auth, initDwellingDateModifiers, isGPA, submissionVM, translator, updateValuationData, updateWizardData, constructionDetailsVM]);

    const onClickEditHomeDetailsButton = useCallback(() => {
        if (!isComponentValid) {
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            setUserClickOnEdit(false)
        } else {
            setVeriskTokenError(false);
            clearBlockAlerts('imagery');
            setEditModeForDwellingConstructionModifiers(false);
            updateShowAdditionalQuestions(false);
            setEditHomeDetails(true);
            updateCloseCovAAlert(true);
            setIsUWIssuesPanelVisible(false);
            onInit(true);
            setUserClickOnEdit(true)
        }
    }, [clearBlockAlerts, errorTimestamp, isComponentValid, onInit, setEditModeForDwellingConstructionModifiers]);

    const writeValue = useCallback((value, path) => {
        setDisableNextButton(false);
        if (!!constructionDetailsVM.replacementCost.value && constructionDetailsVM.isReplacementCostSelected_ML.value && isGrandProtectSelected(offerings)) {
            setDisableNextButton(true);
        } 
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService, constructionDetailsVM]);

    const validateData = useCallback((isReturnToQuote = false) => {
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);
        checkVeriskYearBuiltIsValid(submissionVM);
        setEditModeForDwellingConstructionModifiers(true);
        if (!isComponentValid || !(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if (isReturnToQuote) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', auth.authHeader);
        }
        
        return true;
    }, [auth, checkVeriskYearBuiltIsValid, currentStep.mlStepName, errorTimestamp, isComponentValid, setEditModeForDwellingConstructionModifiers, submissionVM]);

    const onNext = useCallback(async () => {
        if (isGPA) {
            UserService.getCurrentUser(auth.authHeader).then((user) => {
                HOTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Construction Page', action: 'Construction Page Submitted'});
            });
        } else {
            HOTrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Construction Page', action: 'Construction Page Submitted'}, true);
        }

        const isDataValid = await validateData();
        if (!isDataValid) {
            return false;
        }

        let nextStepName;
        if (currentStep.mlStepName === 'compHoDetails') {
            nextStepName = 'quoteCompRaterDetails';
        } else {
            nextStepName = 'hoRating';
        }

        try {
            showProgressDialog(platformMessages.saveSubmission);

            const canSkipSave = steps.some((step) => step.mlStepName === nextStepName && !!step.visited);
            if (!canSkipSave) {
                setIsUWIssuesPanelVisible(false);
                const response = await LoadSaveService.updateDraftSubmission(submissionVM.value, isGPA && auth.authHeader);
                submissionVM.value = response;
                updateWizardData(submissionVM);
                if (checkForDwellingConstructionUwIssues()) {
                    return false;
                }
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, isGPA && auth.authHeader);
            } else {
                if (checkForDwellingConstructionUwIssues()) {
                    return false;
                }
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, isGPA && auth.authHeader);
            }
        } catch (error) {
            if (error?.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                return false;
            } else {
                throw error;
            }
        } finally {
            hideProgressDialog();
        }

        if (!nextStepVisited()) {
            return submissionVM;
        }
        goNext();
        return false;
    }, [LoadSaveService, auth, checkForDwellingConstructionUwIssues, currentStep.mlStepName, goNext, hideProgressDialog, isGPA, nextStepVisited, showProgressDialog, steps, submissionVM, updateWizardData, validateData]);

    const CONSTRUCTION_VM_PATH = 'lobData.homeowners.coverables.constructionVeriskDetails_ML';

    const isOnlyNumbers = (value) => {
        if (_.isNil(value) || value === '') {
            return false;
        }

        return /^[0-9]+$/.test(String(value));
    };

    const getYearBuiltValidationMessages = useCallback(() => {
        const validationMessages = [];

        if (!isQnB) {
            return [];
        }

        const constructionDetails = _.get(
            submissionVM,
            `${CONSTRUCTION_VM_PATH}.value`
        );

        const year = constructionDetails?.yearBuilt;

        if (_.isNil(year) || year === '') {
            validationMessages.push(
                translator(messages.yearBuildRequired)
            );

            return validationMessages;
        }

        if (!isOnlyNumbers(year)) {
            validationMessages.push(
                translator(messages.yearBuildOnlyNumbers)
            );

            return validationMessages;
        }

        if (String(year).length !== 4) {
            validationMessages.push(
                translator(messages.yearBuildOnlyNumbers)
            );
        }

        return validationMessages;
    }, [isQnB, submissionVM, translator]);

    const getActualSquareFootageValidationMessages = useCallback(() => {
        const validationMessages = [];

        if (!isQnB) {
            return [];
        }

        const constructionDetails = _.get(
            submissionVM,
            `${CONSTRUCTION_VM_PATH}.value`
        );

        const actualSquareFootage = constructionDetails?.approxSquareFootage_ML;

        if (_.isNil(actualSquareFootage) || actualSquareFootage === '') {
            validationMessages.push(
                translator(messages.actualSquareFootageRequired)
            );

            return validationMessages;
        }

        if (!isOnlyNumbers(actualSquareFootage)) {
            validationMessages.push(
                translator(messages.actualSquareFootageOnlyNumbers)
            );
        }

        return validationMessages;
    }, [isQnB, submissionVM, translator]);

    const onConstructionButton = useCallback(async () => {
        const yearBuiltValidationMessages = getYearBuiltValidationMessages();
        const actualSquareFootageValidationMessages = getActualSquareFootageValidationMessages();

        if (
            yearBuiltValidationMessages.length > 0
            || actualSquareFootageValidationMessages.length > 0
        ) {
            return false;
        }

        if (!isQnB) {
            return false;
        }

        try {
            showProgressDialog(platformMessages.saveSubmission);

            const constructionDetails = _.get(submissionVM, `${CONSTRUCTION_VM_PATH}.value`);
            const quoteID = _.get(submissionVM, 'quoteID.value');

            const res = await LoadSaveService.getPropertyValuationQB(
                constructionDetails,
                quoteID
            );

            if (!res) {
                clearBlockAlerts('veriskValuationFailed')
                addErrorAlert(translator(messages.veriskValuationFailed), 'veriskValuationFailed');
                return false;
            }

            _.set(submissionVM, CONSTRUCTION_VM_PATH, res);
            updateWizardData(submissionVM);

            const valuationID = _.get(
                submissionVM,
                `${CONSTRUCTION_VM_PATH}.verisk360ValuationID_ML.value`
            );

            const version = _.get(
                submissionVM,
                `${CONSTRUCTION_VM_PATH}.verisk360Version_ML.value`
            );

            if (!valuationID || !version) {
                clearBlockAlerts('veriskValuationResponseInvalid')
                addErrorAlert(translator(messages.veriskValuationResponseInvalid), 'veriskValuationResponseInvalid');
                return false;
            }

            onFinishVeriskIntegration(valuationID, version);
            updateShowAdditionalQuestions(true);

            if (!nextStepVisited()) {
                return submissionVM;
            }
            setUserClickOnEdit(false)

            goNext();
            return true;
        } catch (error) {
            if (error?.baseError?.indexOf('ConcurrentDataChangeException') > -1) {
                MLErrorMessageUtil.handleException(
                    error,
                    showErrorModal,
                    messages.somethingWentWrong
                );

                return false;
            }
            
            clearBlockAlerts('veriskValuationServiceError');
            addErrorAlert(translator(messages.veriskValuationServiceError), 'veriskValuationServiceError');

            return false;
        } finally {
            hideProgressDialog();
        }
    }, [LoadSaveService, addErrorAlert, clearBlockAlerts, getActualSquareFootageValidationMessages, getYearBuiltValidationMessages, goNext, hideProgressDialog, isQnB, nextStepVisited, onFinishVeriskIntegration, showErrorModal, showProgressDialog, submissionVM, translator, updateWizardData]);


    const resolvers = {
        resolveComponentMap: {
            propertyValuationComponent: MLHOPropertyValuationComponent,
            replacementCostSummaryComponent: MLHOReplacementCostSummaryComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent,
            MLAlertGroupComponent
        },
        resolveCallbackMap: {
            onNext,
            onConstructionButton
        }
    };

    const nextStepText = () => {
        return !isCompRater ? 
            <FormattedMessage
                {...messages.nextLabel}
                values={{
                    discount: (
                        <strong>{translator(messages.discountLabel)}</strong>
                    )
                }}
            /> :
            <FormattedMessage
                {...messages.crNextLabel}
                values={{
                    quote: (
                        <strong>{translator(messages.crQuoteLabel)}</strong>
                    )
                }}
            />
    };

    const overrides = {
        propertyValuationComponent: {
            visible: isQnB ? userClickOnEdit && showPropertyValuation : showPropertyValuation,
            token,
            onFinish: onFinishVeriskIntegration,
            onError: handleVeriskError
        },
        replacementCostSummaryComponent: {
            visible: showAdditionalQuestions,
            isCondo,
            accountName: submissionVM.baseData.primaryNamedInsured_ML.displayName.value,
            onValueChange: writeValue,
            dwellingConstructionModifiersML: submissionVM.lobData.homeowners.modifiers_ML.dwellingConstructionModifiers_ML,
            isPolicyChange: false,
            replacementCost,
            submissionVM,
            onClickEditHomeDetailsButton,
            showErrors: showErrors,
            onValidate,
            closeCovAAlert,
            updateWizardData,
            isCompRater,
            setDisableNextButton,
            choosenQuote: _.get(submissionVM, 'bindData.chosenQuote.value', '')
        },
        pageHeader: {
            visible: !isGPA,
            content: isCondo || isLLCondo ? translator(messages.condoDetailsHeader) : translator(messages.homeDetailsHeader)
        },
        stickyContinueSection: {
            visible: isGPA,
            defaultContinueSectionId: 'footer',
            nextDescription: nextStepText(),
            onNext,
            showReturnToQuote
        },
        footer: {
            visible: showAdditionalQuestions
        },
        nextButton: {
            disabled: disableNextButton
        },
        nextDescription: {
            content: nextStepText()
        },
        header: {
            className: isGPA ? 'ml-main-header short' : 'page-header qnbHeader'
        },
        headerText: {
            content: isCondo ? translator(messages.condoDetailsHeader) : translator(messages.homeDetailsHeader)
        },
        pageContainer: {
            className: isGPA && 'page-content-gpa'
        },
        alerts: {
            visible: isGPA
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: true
        },
        uwIssueContainer: {
            visible: isUWIssuesPanelVisible,
            uwIssues: blockingUwIssues,
            jobID: submissionVM.quoteID.value,
            publicID: _.get(submissionVM, 'value.publicID'),
            afterIssuesRefreshedCallback: checkForDisableNextButton,
            submissionVM,
            history
        },
        yearBuiltInput: {
            validationMessages: getYearBuiltValidationMessages(),
            onValueChange: writeValue,
        },
        squareFootageInput: {
            validationMessages: getActualSquareFootageValidationMessages(),
            onValueChange: writeValue,
        },
        constructionContainer:{
            visible: !showAdditionalQuestions && !userClickOnEdit && isQnB  // Construction fields (year build and square footage) are only for QnB Application
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showErrors={showErrors}
            skipWhen={skipOnResumeIf}
            disableNext={disableNextButton}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyContinueSection'
            showReturnToQuote={showReturnToQuote && canRequote}
            disableReturnToQuote={!canRequote || disableNextButton}
            updateWizardData={updateWizardData}
            validateData={validateData}
            history={history}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                onValidationChange={onValidate}
                showErrors={showErrors}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

ConstructionPage.propTypes = wizardProps;
export default withRouter(ConstructionPage);
